import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconScatterPlot = () => {
  return (
    <g>
      <path
        d="M.75 0a.75.75 0 0 1 .743.649L1.5.75v13.748h13.752a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.649.744l-.101.007H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.949V.751A.75.75 0 0 1 .75 0zm3.5 10a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm7-1a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm-4-3a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm2-4a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm5.5-2a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z"
        
      />
    </g>
  );
};

export default withIcon(IconScatterPlot);
